import script from "./OpsUserManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsUserManagement.vue?vue&type=script&setup=true&lang=js"

import "./OpsUserManagement.vue?vue&type=style&index=0&id=befd9eb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-befd9eb4"]])

export default __exports__